import React from 'react';

const Mail = () => {
	return (
		<svg
			width='32'
			height='32'
			viewBox='0 0 32 32'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M4 6.99927H28V23.9993C28 24.2645 27.8946 24.5188 27.7071 24.7064C27.5196 24.8939 27.2652 24.9993 27 24.9993H5C4.73478 24.9993 4.48043 24.8939 4.29289 24.7064C4.10536 24.5188 4 24.2645 4 23.9993V6.99927Z'
				stroke='white'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M28 6.99927L16 17.9993L4 6.99927'
				stroke='white'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default Mail;
